class DoorDesignerService {
    constructor() {
        // console.log('DoorDesignerService loaded.');
    }

    getServiceUrl = () => {
        return routes.shopUrl + theme.prefixes.proxy + "/DoorDesign/";
    }

    getApiHealth() {
        fetch(`/apps/smapi/api/Connection/GetVersion`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((response) => response.text())
            .then((responseText) => {
            })
            .catch((e) => {
                console.error(e);
            });
    };

    getGetValidAddOnOptions(noDoors, callback) {
        fetch(`/apps/smapi/api/DoorDesign/GetValidAddOnOptions?noDoors=${noDoors}`)
            .then((data) => data.json())
            .then((response) => {
                const returnData = this.parseData(response);

                return callback(returnData);
            })
            .catch((e) => {
                console.error(e);
                return callback({
                    success: false,
                    data: 'Invalid data type.'
                });
            });
    };

    getSuggestedDoorQuantity(topWidth, bottomWidth, leftHeight, rightHeight, callback) {
        fetch(`/apps/smapi/api/DoorDesign/SuggestDoorQuantity?topWidth=${topWidth}&bottomWidth=${bottomWidth}&leftHeight=${leftHeight}&rightHeight=${rightHeight}`)
            .then((data) => data.json())
            .then((response) => {
                return callback(this.parseData(response));
            })
            .catch((e) => {
                console.error(e);
                return callback({
                    success: false,
                    data: 'Invalid data type.'
                });
            });
    };

    getProductPriceAudIncGst(productHandle, callback) {
        fetch(`/apps/smapi/api/DoorDesign/getProductPriceAudIncGst?productHandle=${productHandle}`)
            .then((data) => data.json())
            .then((response) => {
                return callback(this.parseData(response));
            })
            .catch((e) => {
                console.error(e);
                return callback({
                    success: false,
                    data: 'Invalid data type.'
                });
            });
    };

    onCreateProduct(data, callback) {
        if (data instanceof DoorRequestConfiguration == false) {
            return callback({
                success: false,
                data: 'Invalid data type.'
            });
        }

        fetch(`/apps/smapi/api/DoorDesign/CreateAggregateProduct`, {   
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
                },
                body: data.toString()
            })
            .then((data) => data.json())
            .then((data) => {
                return callback(this.parseData(data));
            })
            .catch((e) => {
                return callback({
                    success: false,
                    data: e
                });
            });

        
    };

    onCreateProductEstimate(data, callback) {
        if (data instanceof DoorRequestConfiguration == false) {
            console.log('eee');
            return callback({
                success: false,
                data: 'Invalid data type.'
            });
        }

        fetch(`/apps/smapi/api/DoorDesign/DoorEstimates`, {   
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
                },
                body: data.toString()
            })
            .then((data) => data.json())
            .then((data) => {
                return callback(this.parseData(data));
            })
            .catch((e) => {
                return callback({
                    success: false,
                    data: e
                });
            });

        
    };



    parseData(data) {
        if ((data.hasOwnProperty('statusCode') && data.statusCode >= 400) ||
            (data.hasOwnProperty('status') && data.status >= 400))
        {
            return {
                success: false,
                data: data
            };
        } else {
            return {
                success: true,
                data: data
            };
        }
    }
}